/** Popular destinations shown before the user types (dummy list). */
export const POPULAR_FLIGHT_PLACES = [
  {
    type: 'city',
    code: 'NYC',
    name: 'New York',
    city_name: 'New York',
    country_name: 'United States',
    country_code: 'US',
  },
  {
    type: 'city',
    code: 'LON',
    name: 'London',
    city_name: 'London',
    country_name: 'United Kingdom',
    country_code: 'GB',
  },
  {
    type: 'city',
    code: 'PAR',
    name: 'Paris',
    city_name: 'Paris',
    country_name: 'France',
    country_code: 'FR',
  },
  {
    type: 'airport',
    code: 'DXB',
    name: 'Dubai International Airport',
    city_name: 'Dubai',
    country_name: 'United Arab Emirates',
    country_code: 'AE',
  },
  {
    type: 'city',
    code: 'TYO',
    name: 'Tokyo',
    city_name: 'Tokyo',
    country_name: 'Japan',
    country_code: 'JP',
  },
  {
    type: 'airport',
    code: 'LAX',
    name: 'Los Angeles International Airport',
    city_name: 'Los Angeles',
    country_name: 'United States',
    country_code: 'US',
  },
  {
    type: 'airport',
    code: 'MIA',
    name: 'Miami International Airport',
    city_name: 'Miami',
    country_name: 'United States',
    country_code: 'US',
  },
  {
    type: 'airport',
    code: 'ORD',
    name: "O'Hare International Airport",
    city_name: 'Chicago',
    country_name: 'United States',
    country_code: 'US',
  },
  {
    type: 'city',
    code: 'BKK',
    name: 'Bangkok',
    city_name: 'Bangkok',
    country_name: 'Thailand',
    country_code: 'TH',
  },
  {
    type: 'city',
    code: 'SIN',
    name: 'Singapore',
    city_name: 'Singapore',
    country_name: 'Singapore',
    country_code: 'SG',
  },
  {
    type: 'city',
    code: 'DEL',
    name: 'Delhi',
    city_name: 'Delhi',
    country_name: 'India',
    country_code: 'IN',
  },
  {
    type: 'airport',
    code: 'SYD',
    name: 'Sydney Kingsford Smith Airport',
    city_name: 'Sydney',
    country_name: 'Australia',
    country_code: 'AU',
  },
];

export const POPULAR_CITY_PLACES = [
  {
    type: 'city',
    code: 'PAR',
    name: 'Paris',
    city_name: 'Paris',
    country_name: 'France',
    country_code: 'FR',
  },
  {
    type: 'city',
    code: 'LON',
    name: 'London',
    city_name: 'London',
    country_name: 'United Kingdom',
    country_code: 'GB',
  },
  {
    type: 'city',
    code: 'NYC',
    name: 'New York',
    city_name: 'New York',
    country_name: 'United States',
    country_code: 'US',
  },
  {
    type: 'city',
    code: 'DXB',
    name: 'Dubai',
    city_name: 'Dubai',
    country_name: 'United Arab Emirates',
    country_code: 'AE',
  },
  {
    type: 'city',
    code: 'TYO',
    name: 'Tokyo',
    city_name: 'Tokyo',
    country_name: 'Japan',
    country_code: 'JP',
  },
  {
    type: 'city',
    code: 'BKK',
    name: 'Bangkok',
    city_name: 'Bangkok',
    country_name: 'Thailand',
    country_code: 'TH',
  },
  {
    type: 'city',
    code: 'ROM',
    name: 'Rome',
    city_name: 'Rome',
    country_name: 'Italy',
    country_code: 'IT',
  },
  {
    type: 'city',
    code: 'BCN',
    name: 'Barcelona',
    city_name: 'Barcelona',
    country_name: 'Spain',
    country_code: 'ES',
  },
  {
    type: 'city',
    code: 'AMS',
    name: 'Amsterdam',
    city_name: 'Amsterdam',
    country_name: 'Netherlands',
    country_code: 'NL',
  },
  {
    type: 'city',
    code: 'SIN',
    name: 'Singapore',
    city_name: 'Singapore',
    country_name: 'Singapore',
    country_code: 'SG',
  },
  {
    type: 'city',
    code: 'SYD',
    name: 'Sydney',
    city_name: 'Sydney',
    country_name: 'Australia',
    country_code: 'AU',
  },
  {
    type: 'city',
    code: 'LAX',
    name: 'Los Angeles',
    city_name: 'Los Angeles',
    country_name: 'United States',
    country_code: 'US',
  },
];

/** Extra airports/cities for local typeahead (no API). */
const EXTRA_DUMMY_PLACES = [
  { type: 'airport', code: 'JFK', name: 'John F. Kennedy International Airport', city_name: 'New York', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'EWR', name: 'Newark Liberty International Airport', city_name: 'Newark', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'LGA', name: 'LaGuardia Airport', city_name: 'New York', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'LHR', name: 'Heathrow Airport', city_name: 'London', country_name: 'United Kingdom', country_code: 'GB' },
  { type: 'airport', code: 'LGW', name: 'Gatwick Airport', city_name: 'London', country_name: 'United Kingdom', country_code: 'GB' },
  { type: 'airport', code: 'CDG', name: 'Charles de Gaulle Airport', city_name: 'Paris', country_name: 'France', country_code: 'FR' },
  { type: 'airport', code: 'ORY', name: 'Orly Airport', city_name: 'Paris', country_name: 'France', country_code: 'FR' },
  { type: 'airport', code: 'HND', name: 'Haneda Airport', city_name: 'Tokyo', country_name: 'Japan', country_code: 'JP' },
  { type: 'airport', code: 'NRT', name: 'Narita International Airport', city_name: 'Tokyo', country_name: 'Japan', country_code: 'JP' },
  { type: 'airport', code: 'SFO', name: 'San Francisco International Airport', city_name: 'San Francisco', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'SEA', name: 'Seattle-Tacoma International Airport', city_name: 'Seattle', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'BOS', name: 'Boston Logan International Airport', city_name: 'Boston', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'ATL', name: 'Hartsfield-Jackson Atlanta International Airport', city_name: 'Atlanta', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'DFW', name: 'Dallas/Fort Worth International Airport', city_name: 'Dallas', country_name: 'United States', country_code: 'US' },
  { type: 'airport', code: 'YYZ', name: 'Toronto Pearson International Airport', city_name: 'Toronto', country_name: 'Canada', country_code: 'CA' },
  { type: 'airport', code: 'YVR', name: 'Vancouver International Airport', city_name: 'Vancouver', country_name: 'Canada', country_code: 'CA' },
  { type: 'airport', code: 'FRA', name: 'Frankfurt Airport', city_name: 'Frankfurt', country_name: 'Germany', country_code: 'DE' },
  { type: 'airport', code: 'AMS', name: 'Amsterdam Airport Schiphol', city_name: 'Amsterdam', country_name: 'Netherlands', country_code: 'NL' },
  { type: 'airport', code: 'IST', name: 'Istanbul Airport', city_name: 'Istanbul', country_name: 'Turkey', country_code: 'TR' },
  { type: 'airport', code: 'DOH', name: 'Hamad International Airport', city_name: 'Doha', country_name: 'Qatar', country_code: 'QA' },
  { type: 'airport', code: 'BOM', name: 'Chhatrapati Shivaji Maharaj International Airport', city_name: 'Mumbai', country_name: 'India', country_code: 'IN' },
  { type: 'city', code: 'CHI', name: 'Chicago', city_name: 'Chicago', country_name: 'United States', country_code: 'US' },
  { type: 'city', code: 'MIA', name: 'Miami', city_name: 'Miami', country_name: 'United States', country_code: 'US' },
  { type: 'city', code: 'SFO', name: 'San Francisco', city_name: 'San Francisco', country_name: 'United States', country_code: 'US' },
  { type: 'city', code: 'TOR', name: 'Toronto', city_name: 'Toronto', country_name: 'Canada', country_code: 'CA' },
  { type: 'city', code: 'BOM', name: 'Mumbai', city_name: 'Mumbai', country_name: 'India', country_code: 'IN' },
  { type: 'city', code: 'HKG', name: 'Hong Kong', city_name: 'Hong Kong', country_name: 'Hong Kong', country_code: 'HK' },
  { type: 'city', code: 'IST', name: 'Istanbul', city_name: 'Istanbul', country_name: 'Turkey', country_code: 'TR' },
];

function dedupePlaces(list) {
  const seen = new Set();
  return list.filter((p) => {
    const key = `${p.type}:${p.code}:${p.name}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

/** Full local place list for typeahead search. */
export const ALL_DUMMY_PLACES = dedupePlaces([
  ...POPULAR_FLIGHT_PLACES,
  ...POPULAR_CITY_PLACES,
  ...EXTRA_DUMMY_PLACES,
]);
